<se-fe-modal class="pl-modal--medium" #modal>
  <div seFeModalHeader>
    <se-fe-modal-header
      seFeDataTitle="{{ 'PERSONAS.MERGE_CONFIRMATION_MODAL.header' | translate }}"
      (seFeButtonAction)="modal.close()">
    </se-fe-modal-header>
  </div>
  <div seFeModalContent>
    <section>
      <div pl-grid="loose nowrap">
        <div pl-grid-el pl-grid="shrink@phone">
          <div
            [style.background-image] = "avatarBackgroundImage"
            class="pl-avatar">
          </div>
        </div>
        <div pl-grid-el pl-grid="grow@phone tight">
          <div>
            {{ "PERSONAS.MERGE_CONFIRMATION_MODAL.body" | translate: { keep: keepPersona?.firstLastSuffix, merge: mergePersona?.firstLastSuffix } }}
          </div>
          <div>
            {{ "PERSONAS.MERGE_CONFIRMATION_MODAL.body2" | translate: { merge: mergePersona?.firstLastSuffix } }}
          </div>
        </div>
      </div>
    </section>

    <section
      *ngIf="mergeError"
      test-id="merge-confirmation-modal-failure"
      class="pl-modal__footer pl-form-actions--condensed">
      <div class="pl-form-actions__info">
        <se-fe-icon seFeDataName="warning" seFeDataSize="600" seFeDataColor="warn"></se-fe-icon>
        <span>{{ "PERSONAS.MERGE_CONFIRMATION_MODAL.error" | translate }}</span>
      </div>
      <div class="pl-form-actions__button-container">
        <button type="button"
          test-id="merge-confirmation-modal-retry"
          set-focus
          spinner-button
          class="pl-button"
          spinner-click="mergePersonas()">
          <span>{{ "MODAL.retry" | translate }}</span>
        </button>
      </div>
    </section>
  </div>

  <div seFeModalFooter>
    <se-fe-modal-footer
      [seFeDataFooterButtons]="options">
    </se-fe-modal-footer>
  </div>
</se-fe-modal>

<se-fe-modal #modal2>
  <se-fe-modal-header
    seFeDataTitle="{{ 'PERSONAS.MERGE_CONFIRMATION_MODAL.header' | translate }}"
    (seFeButtonAction)="modal2.close()">
  </se-fe-modal-header>
  <div seFeModalContent>
    {{ "PERSONAS.MERGE_CONFIRMATION_MODAL.body3" | translate: { keep: keepPersona?.firstLastSuffix, merge: mergePersona?.firstLastSuffix } }}
  </div>
  <div seFeModalFooter>
    <se-fe-modal-footer
      [seFeDataFooterButtons]="options2">
    </se-fe-modal-footer>
  </div>
</se-fe-modal>
